import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextRotationNoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"text_rotation_none"}/>
}
